module.exports = __webpack_public_path__ + "static/img/smcode.aa3947e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smcode.png
// module id = V6Lm
// module chunks = 46